import React from 'react';
import {Route, Routes} from 'react-router-dom';
import NavLink from './../../../../common/nav_link'
import VoiceRateList from './list'

export default class extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            routes: [
                {type: 'route', url: '', name: 'Rate Tables'},
              
            ],
            data: {data:[], metadata: []}
        }
    }
    // componentDidMount() {
    //     this.loadFromServer();
    // }
    // loadFromServer() {
    //     const url = `/admin/products/voice/rates`;
    //     this.props.childProps.dataProvider.getList(url, {}).then(
    //         response => 
    //         this.setState({
    //             loading: false,
    //             data: response.data
    //         })
    //     );
    // }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            {this.state.routes.map(function(row, index) {
                                return (
                                    <NavLink
                                        key={ index }
                                        to={`/admin/products/voice/rates/${ row.url }`}
                                        default={`/admin/products/voice/rates`}
                                    >
                                        {/* { row.name } */}
                                    </NavLink>
                                )
                            }, this)}
                        </ul>
                    </div>
                </div>
                <Routes>
                    <Route index element={<VoiceRateList routes={this.props.routes} childProps={this.props.childProps} parent={this.state.data}/>} />
                    {this.props.routes && this.props.routes.map((route, i) => {
                        if (!route.path) return null;
                        // Extract the relative path by removing the parent path prefix
                        const relativePath = route.path.replace('/admin/products/voice/rates', '');
                        return (
                            <Route key={i} path={relativePath} 
                                element={<route.component routes={route.routes} childProps={this.props.childProps} parent={this.state.data}/>} 
                            />
                        );
                    })}
                </Routes>
            </div>
        )
    }
};
